export const apiUrl = "https://stitchify-backend-ba864dc728f1.herokuapp.com";

// export const apiUrl = "https://ea7e3de00c6b.ngrok-free.app";

// live 0
export const s3Url = "https://stitchify.s3.ap-southeast-2.amazonaws.com";
export const imageUrl = (url) => `${s3Url}/${url}`;
export const mediaUrl = (url) => `${s3Url}/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};
